export enum SelectionItemEvent {
  ARCHIVE_PROPOSAL = 'selection-item-archive-proposal',
  ADD_PROPOSAL = 'selection-item-add-proposal',
  MOBILE_NAVBAR_VISIBLE = 'mobile-navbar:visible',
  MOBILE_NAVBAR_HIDDEN = 'mobile-navbar:hidden',
}

export enum Slider {
  CREATE_PROPOSAL = 'offer-proposal',
}
